import { numberWithCommas } from "../../../../constants/utils";
import atoms from "../../../atoms";
import molecules from "../../../molecules";
import { BulkInventoryAddProps, HandleBulkInventoryApiReturn, TExcelData } from "./interface";

const { Input, Button, Table,CustomImages } = atoms;
const {InventoryBulkTable} = molecules

const BulkInventoryAdd = ({
  handleDownloadSampleFormate,
  handleFileUpload,
  inventoryData,
  // excelData,
  handleSubmit,
  isLoading
}: BulkInventoryAddProps) => {

  const columns = [
    {
      name: "Store Name",
      selector: (row: HandleBulkInventoryApiReturn) => row.store.store_location,
      sortable: true,
      minWidth: "15%",
    },
    {
      name: "Product ID",
      selector: (row: HandleBulkInventoryApiReturn) => row.product_id_display,
      sortable: true,
      minWidth: "15%",
    },
    {
      name: "Cover Photo",
      cell: (row: HandleBulkInventoryApiReturn) => (
          <CustomImages src={row?.images && row?.images[0]} />
      ),
      center: true,
    },
    {
      name: "Product Type",
      selector: (row: HandleBulkInventoryApiReturn) => row.product_type,
      sortable: true,
      minWidth: "15%",
    },
    {
      name: "Model Number",
      selector: (row: HandleBulkInventoryApiReturn) => row.modal_number,
      sortable: true,
      minWidth: "15%",
    },
    {
      name: "Glass Size",
      selector: (row: HandleBulkInventoryApiReturn) => row.glass_size,
      sortable: true,
      minWidth: "15%",
    },
    {
      name: "Product SRP",
      selector: (row: HandleBulkInventoryApiReturn) => row.product_srp,
      sortable: true,
      minWidth: "15%",
    },
    {
      name: "Unit Cost Amount",
      selector: (row: HandleBulkInventoryApiReturn) => numberWithCommas(Number(row.unit_const_amount)),
      sortable: true,
      minWidth: "15%",
    },
    {
      name: "Remark",
      selector: (row: HandleBulkInventoryApiReturn) => row.remarks, 
      sortable: true,
      minWidth: "15%",
    },
  ];



  return (
    <>
      <div className="row">
        <div className="px-2 d-flex justify-content-between">
          <div className='d-flex align-items-center gap-2'>
            <label className='inputs-label mb-2 fs-16 fw-600  secondary-color'>{"Upload XLSX File"}</label>
            <Input
              type="file"
              id="formFile"
              accept='.xlsx, .xls, .csv'
              multiple={true}
              onChange={handleFileUpload}
              placeholder={"formate :- .xlsx, .xls"}
              onClick={(e: any) => (e.target.value = null)}
            />
          </div>
          <Button onClick={() => handleDownloadSampleFormate()}>Download Format </Button>
        </div>

        {/* table for show the excel data */}
        {inventoryData && <Table columns={columns} data={inventoryData} />}

        {/* submit button */}
       {inventoryData && <div className="d-flex justify-content-center mt-3">
          <Button onClick={()=>handleSubmit()} isDisabled={isLoading}>Submit</Button>
        </div>}

        {/* Invalid data table */}
        <div className="fs-16 fw-600 ">Invalid Data</div>
      </div>
    </>
  )
};

export default BulkInventoryAdd;